import React, { useEffect, useState } from 'react';
import {
  Col,
  Row,
  Input,
  Label,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'reactstrap';

const Messages = ({ item, messageData, setMessageData, indexValue, hasSequenceErr }) => {
  const [itemDetail, setItemDetail] = useState();
  const [itemHeader, setItemHeader] = useState();
  const [itemSequence, setItemSequence] = useState(item.sequence);
  const [sequenceArr, setSequenceArr] = useState([]);

  useEffect(() => {
    // get messages length
    const messageDataLength = messageData.length;
    if (messageDataLength > 0) {
      const newSequenceArr = [];
      // loop over array to push indexes for sequence adjustment
      for (let index = 1; index <= messageDataLength; index++) {
        newSequenceArr.push(index);
      }
      setSequenceArr(newSequenceArr);
      setItemDetail(item.detail);
      setItemHeader(item.header);
    }
  }, [messageData, item.detail]);

  const handleDetailChange = (e) => {
    setItemDetail(e.target.value);

    const newMessageArr = messageData;
    newMessageArr[indexValue] = { ...messageData[indexValue], detail: e.target.value };
    setMessageData(newMessageArr);
  };

  const handleHeaderChange = (e) => {
    setItemHeader(e.target.value);

    const newMessageArr = messageData;
    newMessageArr[indexValue] = { ...messageData[indexValue], header: e.target.value };
    setMessageData(newMessageArr);
  };

  const handleSequenceChange = (sequenceValue) => {
    setItemSequence(sequenceValue);

    const newMessageArr = messageData;
    newMessageArr[indexValue] = { ...messageData[indexValue], sequence: sequenceValue };
    setMessageData(newMessageArr);
  };

  const handleDeleteMessage = () => {
    const newMessageArr = messageData.filter((arr, index) => index !== indexValue);
    setMessageData(newMessageArr);
  };

  return (

    <div key={indexValue} className="mt-4">
      <Row>
        <Col xs={1}>
          <UncontrolledDropdown disabled={indexValue === 0} className={`${hasSequenceErr ? 'dropdown-error' : ''}`}>
            <DropdownToggle caret color="white" className="text-truncate small-important">
              {itemSequence}&nbsp;
            </DropdownToggle>
            <DropdownMenu className="full-width-dropdown">
              { sequenceArr && sequenceArr.map((number, i) => (
                <DropdownItem
                  key={`dropDownItem${i}`}
                  className="w-100 text-clamp-2 small-important"
                  onClick={() => handleSequenceChange(number)}
                  active={itemSequence === number}
                  disabled={number === 1}
                >
                  {number}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </UncontrolledDropdown>
        </Col>
        <Col xs={11} sm={4} className={`${item.header ? 'mt-2' : ''}`}>
          {item.header
          && <Label className="fw-bold no-caps">{item.header}</Label>}
          {!item.header
            && (
            <Input
              id="messageText"
              name="messageText"
              value={itemHeader}
              onChange={(e) => handleHeaderChange(e)}
            />
            )}
        </Col>
      </Row>
      {hasSequenceErr
                    && (
                    <div
                      className="control-label error-message mt-1"
                      htmlFor="taxRate"
                    >
                      Sequence number must be unique
                    </div>
                    )}
      <Row className="mt-3">
        <Col xs={12} sm={8}>
          <Input
            id="messageText"
            name="messageText"
            type="textarea"
            value={itemDetail}
            onChange={(e) => handleDetailChange(e)}
          />
        </Col>
        { !(item.header === 'Payment Option(s)' || item.header === 'Shipping Notes')
          && (
            <Col xs={12} sm={3}>
              <button
                type="button"
                className="btn btn-link"
                onClick={() => handleDeleteMessage(item)}
              >
                Delete this message
              </button>
            </Col>
          )}
      </Row>
    </div>
  );
};

export default Messages;
